import { AntSelect, AntSelectPropsGeneric } from 'controls/react/ant/antSelect';
import { observer } from 'mobx-react';
import React, { FC } from 'react';

import { translator } from 'core/localization';
import { DataSourceSelectorProps } from './types';
import { useRemoteListForSelect } from 'framework/api';
import { DataSource } from 'areas/data-sources/types/dataSource';
import { getDataSources } from 'controls/designer/features/widgets/datasources/api';

const i = translator({
	'Select datasource...': {
		no: 'Velg datakilde...',
	},
});

export const DataSourceSelector: FC<DataSourceSelectorProps> = observer(({ manager, options, ...rest }) => {
	return <AntSelect placeholder={i('Select datasource...')} options={options ?? manager.dataSourcesOptions} {...rest} />;
});

export type DataSourceSelectorPlainProps = AntSelectPropsGeneric<string> & {
	accountId?: string;
	dataSources?: DataSource[];
};

export const DataSourceSelectorPlain = observer((props: DataSourceSelectorPlainProps) => {
	const { accountId, ...rest } = props;
	const remoteData = useRemoteListForSelect(getDataSources({ accountId: accountId }), {
		sort: true,
		labelField: 'name',
		valueField: 'id',
	});

	return <AntSelect placeholder={i('Select datasource...')} {...remoteData} {...rest} />;
});
